/*
DoubleIncPage.js
双增公式页面
 */
import React, {useEffect, useState} from "react";
import {Button, Drawer, Flex, FloatButton, Collapse, Space, Spin} from "antd";
import {CloseOutlined, QuestionOutlined} from "@ant-design/icons";

import {DoubleIncFormulaIcon} from "./Images/DoubleIncFormulaIcon";
import Point5Icon from "../../Common/PointFive/Point5Icon";
import DoubleIncCardsView from "./DoubleIncCardsView/DoubleIncCardsView";
import {DoubleIncDescription} from "./Model/DoubleIncDescription";
import getDoubleIncAnalysisQuery from "./Model/getDoubleIncAnalysisQuery";
import {DefaultURL} from "../../Common/constants";
import DoubleIncAnalysisCard from "./DoubleIncAnalysisCard/DoubleIncAnalysisCard";

const DoubleIncPage = ({doubleIncShow = false, onClose, isMobile}) => {
    // 双增公式简介drawer开关
    const [descriptionDrawerOpen, setDescriptionDrawerOpen] = useState(false);
    // 分析的结果
    const [analysisText, setAnalysisText] = useState('');
    const [analysisLoading, setAnalysisLoading] = useState(false);

    useEffect(() => {
        const result = localStorage.getItem('DoubleIncAnalysis');
        if (result && result.length !== 0) {
            setAnalysisText(result);
        }
    }, []);

    // 开启双增公式简介二级drawer
    const handleDoubleIncDesDrawerOpen = () => {
        setDescriptionDrawerOpen(true);
    };

    // 关闭双增公式简介二级drawer
    const handleDoubleIncDesDrawerClose = () => {
        setDescriptionDrawerOpen(false);
    };

    // 点击开始分析按钮
    const handleDoubleIncAnalysisClicked = async () => {
        setAnalysisLoading(true);
        const query = await getDoubleIncAnalysisQuery();
        const response = await fetch(`${DefaultURL}api/chat/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                query: query, // 发送的 prompt
                history: [], // 发送的历史记录
                user: 'point5',
            }),
        });
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let done = false;
        let result = "";
        setAnalysisLoading(false);
        while (!done) {
            const {value, done: doneReading} = await reader.read();
            done = doneReading;

            if (value) {
                const chunk = decoder.decode(value);
                result += chunk;
                // 更新前端显示
                setAnalysisText(result);
            }
        }
        // 使用 localStorage 本地存储数据
        localStorage.setItem('DoubleIncAnalysis', result);
    };

    return (
        <Drawer title='双增公式' placement='left' width={isMobile ? '100%' : '85%'} open={doubleIncShow}
                closeIcon={null}
                extra={isMobile ?
                    (<Space size='large'>
                        <Button shape='circle' size='large' onClick={handleDoubleIncDesDrawerOpen}
                                icon={<QuestionOutlined/>}/>
                        <Button shape='circle' size='large' onClick={handleDoubleIncAnalysisClicked}
                                icon={<Point5Icon/>}/>
                        <Button type='text' icon={<CloseOutlined style={{color: '#808080'}}/>} size='large'
                                onClick={onClose}/>
                    </Space>) :
                    (<Button type='text' icon={<CloseOutlined style={{color: '#808080'}}/>} size='large'
                             onClick={onClose}/>)}>
            <Spin spinning={analysisLoading} size="large" tip='正在分析中...'>
                <Flex vertical={true} justify='center' align='center' gap='large'>
                    <DoubleIncFormulaIcon style={{width: isMobile ? '90%' : '60%', height: 'auto'}}/>
                    <DoubleIncCardsView isMobile={isMobile}/>
                    <DoubleIncAnalysisCard result={analysisText}/>
                </Flex>
            </Spin>
            <Drawer title="什么是双增公式？" width={isMobile ? '100%' : '40%'} placement='left'
                    open={descriptionDrawerOpen}
                    onClose={handleDoubleIncDesDrawerClose}>
                <Collapse items={DoubleIncDescription} defaultActiveKey={['1']} ghost={true}/>
            </Drawer>
            {/*桌面PC展示悬浮窗*/}
            {!isMobile &&
                <FloatButton.Group shape='circle' style={{position: "absolute", insetInlineEnd: 50, bottom: 80}}>
                    <FloatButton tooltip='什么是双增公式？' onClick={handleDoubleIncDesDrawerOpen}
                                 icon={<QuestionOutlined/>} style={{width: '50px', height: '50px'}}/>
                    <FloatButton tooltip='分析一下？' onClick={handleDoubleIncAnalysisClicked} icon={<Point5Icon/>}
                                 style={{width: '50px', height: '50px'}}/>
                </FloatButton.Group>
            }
        </Drawer>
    );
};

export default DoubleIncPage;